import { useRequest } from 'domain/core/hooks/useRequest';
import { ApiMethodsEnum } from 'infrastructure/enums/ApiMethodsEnum';

export const JOB_POSTS_ITEMS_PER_PAGE = 10;

export const useGetActiveOrDraftJobPosts = () => {
  const { data, isLoading, error, send } = useRequest({
    method: ApiMethodsEnum.Get,
    sendOnStart: false,
  });

  const getActiveJobPosts = (page: number = 1, limit: number = JOB_POSTS_ITEMS_PER_PAGE) => {
    send({}, `/api/v1/jobPosts?limit=${limit}&page=${page}&postStatus=active`).then();
  };

  const getDraftsJobPosts = (page: number = 1, limit: number = JOB_POSTS_ITEMS_PER_PAGE) => {
    send({}, `/api/v1/jobPosts?limit=${limit}&page=${page}&postStatus=draft`).then();
  };

  return {
    getActiveJobPosts,
    getDraftsJobPosts,
    data,
    isLoading,
    error,
  };
};
